import { render, staticRenderFns } from "./CustomersFilter.vue?vue&type=template&id=6ca37df4&scoped=true"
import script from "./CustomersFilter.vue?vue&type=script&lang=js"
export * from "./CustomersFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomersFilter.vue?vue&type=style&index=0&id=6ca37df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca37df4",
  null
  
)

export default component.exports